export enum StatusCode {
  NotModified = 304,
  BadRequest = 400,
  Unauthorised = 401,
  Forbidden = 403,
  NotFound = 404,
  Conflict = 409,
  InternalServerError = 500
}

export interface NetworkError extends Error {
  status: number;
  response?: Response;
}

// https://tanstack.com/query/latest/docs/framework/react/reference/useMutation#usemutation
export interface MutationOptions {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
  onSettled?: () => void;
  meta?: {
    /**
     * Need to add below metadata if error is handled at component level
     * to override global error handling
     * https://github.com/TanStack/query/discussions/3441
     */
    isErrorHandled: boolean;
  };
}
